import { ComponentProps, FC } from 'react'
import { addDisplayName, addProps, flowMax } from 'ad-hok'
import { createUseStyles } from 'react-jss'
import cx from 'classnames'

import { Button } from './Button'

interface Props extends ComponentProps<typeof Button> {
  image: string
  width: number
  height: number
}

const useStyles = createUseStyles({
  button: {
    position: 'relative',
    minWidth: 44,
    minHeight: 44,
  },
  image: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: ({ width }: Props) => width,
    height: ({ height }: Props) => height,
  },
})

export const ImageButton: FC<Props> = flowMax(
  addDisplayName('ImageButton'),
  addProps((props) => ({
    classes: useStyles(props),
  })),
  ({ image, children, className, classes, ...props }) => (
    <Button className={cx(classes.button, className)} {...props}>
      <img src={image} className={classes.image} alt="" />
      {children}
    </Button>
  )
)
